import {
  GatsbyImage,
} from 'gatsby-plugin-image';

import type { IImageProps } from './types';
import { useEagerLoadingContext } from '@klv/context/eager-loading';

const Image = ({
  altText = '',
  imageData,
  isDecorative = false,
  ...props
}: IImageProps) => {

  const eagerLoad = useEagerLoadingContext();
  // if we have a prop for loading use that first, otherwise use the context
  const eagerLoadValue = props.loading || eagerLoad;

  const a11yHidden = isDecorative || !altText;

  return (
    <GatsbyImage
      {...props}
      alt={a11yHidden ? '' : altText}
      aria-hidden={a11yHidden}
      image={imageData}
      loading={eagerLoadValue}
    />
  );
};

export default Image;
